import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { IhdDetails } from "@/models/ihdDetails/ihdDetails"
import { SmartMeterService } from "@/services/operations/SmartMeterService"
import { MeterpointService } from "@/services/MeterpointService"

export const getIhdDetails = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const meterPointsQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterPointsQuery)

  const meterpoints = meterPointsQuery.data
    .map((meterpoint) => meterpoint.identifier)
    .join()

  const ihdDetailsQuery = SmartMeterService.getIhdDetails(meterpoints)

  queries.add(ihdDetailsQuery)

  const data: IhdDetails[] = ihdDetailsQuery.data

  return queries.setData(data).getAggregate()
}
